import { validationCNPJ } from "components/utils/validationsFN";
import formatter from "utils/formatter";
import * as yup from "yup";

type RegistrationMode = "price" | "tax";

const currencySchema = (required: boolean) => {
    const field = yup
        .string()
        .nullable()
        .max(15, "Valor máximo R$ 9.999.999,99");

    return required ? field.required("Campo obrigatório") : field;
};

export const createSchema = (mode: RegistrationMode) => yup
    .object({
        ufTaxa: yup.string().required("Campo obrigatório"),
        descricao: yup.string().required("Campo obrigatório"),
        tipoVeiculo: yup.string().required("Campo obrigatório"),
        cnpjAgenteFinanceiro: yup
            .string()
            .nullable()
            .test("cnpj-valido", "CNPJ informado é inválido", (value) => {
                const cnpj = formatter.onlyNumber(value ?? "");

                if (!cnpj) return true;

                return validationCNPJ(cnpj);
            }),
        publica:
            mode === "price"
                ? yup.string().required("Campo obrigatório")
                : yup.string().nullable(),
        ativa: yup.string().required("Campo obrigatório"),
        valorTaxaRegistro: currencySchema(mode === "tax"),
        valorRegistradora: currencySchema(mode === "price"),
        valorTaxaAditivo: currencySchema(mode === "tax"),
        dataVigenciaInicio: yup
            .mixed<string>()
            .concat(yup.date())
            .transform((curr, orig) => (orig === "" ? null : curr))
            .nullable()
            .required("Campo obrigatório"),
        dataVigenciaFim: yup
            .mixed<string>()
            .concat(yup.date())
            .transform((curr, orig) => (orig === "" ? null : curr))
            .when("dataVigenciaInicio", (dataVigenciaInicio, schema) => {
                return dataVigenciaInicio
                    ? schema.min(
                        dataVigenciaInicio,
                        "A Data Final não pode ser inferior à data de início",
                    )
                    : schema;
            })
            .nullable()
            .required("Campo obrigatório"),
    })
    .required();
